import type { TListPaginationSearchSchema } from './list-pagination-search-schema';

export const listPaginationLoaderDeps = (
    pageNum?: TListPaginationSearchSchema['pageNum'],
    pageSize?: TListPaginationSearchSchema['pageSize']
): TListPaginationSearchSchema => ({
    pageNum: pageNum || 0,
    pageSize: pageSize || 25,
});
